import { FC } from 'react';
import cn from 'classnames';
import { buildTranslateProps } from '../i18nEngine';
import { tolgee } from '../tolgee';
import { tProps } from '../types';
import { useTolgeeUpdates } from './useTolgeeUpdates';

const Translate: FC<tProps> = ({ str, params, scope, setDangerously, className }) => {
  useTolgeeUpdates();
  // tolgee.t output is observable by Tolgee's in-context editing session
  // (ALT+click with the Tolgee Tools browser extension).
  // @tolgee-ignore
  const text = tolgee.t(buildTranslateProps(str, { ...params, scope }));

  if (setDangerously) {
    return (
      <span
        className={cn(className)}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: text
        }}
      />
    );
  }

  return <span className={cn(className)}>{text}</span>;
};

export default Translate;
